export default __webpack_public_path__ + "static/media/vip-6.5f10cf2d.webp";